import {
  Accordion,
  AccordionHeader,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  AccordionTitle,
  Card,
  CardBody,
  Group,
  List,
} from '@apollo/orbit';
import React from 'react';

import { DescriptionTermListItem } from '../components/DescriptionTermListItem';
import { HeadersList } from '../components/HeadersList';
import { HTTPStatusBadge } from '../components/HTTPStatusBadge';
import { ConnectorsDebuggingResponse } from '../shared';

export interface Props {
  response: ConnectorsDebuggingResponse;
}

export const ResponseOverview = ({ response }: Props) => {
  const { headers = [], status } = response;
  return (
    <Card variant="unstyled">
      <CardBody>
        <Accordion allowMultiple defaultIndex={[0]}>
          {status !== undefined && (
            <AccordionItem>
              <AccordionHeader>
                <Group align="start">
                  <AccordionIcon />
                  <AccordionTitle>General</AccordionTitle>
                </Group>
              </AccordionHeader>
              <AccordionPanel className="overflow-auto">
                <List as="dl">
                  <DescriptionTermListItem
                    term="Status code"
                    details={<HTTPStatusBadge status={status} />}
                  />
                </List>
              </AccordionPanel>
            </AccordionItem>
          )}
          <AccordionItem>
            <AccordionHeader>
              <Group align="start">
                <AccordionIcon />
                <AccordionTitle>
                  Response headers ({headers.length})
                </AccordionTitle>
              </Group>
            </AccordionHeader>
            <AccordionPanel className="overflow-auto">
              <HeadersList headers={headers} />
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </CardBody>
    </Card>
  );
};
